module.exports = __webpack_public_path__ + "static/media/santa-isabel-login.9bd17a5f.svg";